module.exports = __webpack_public_path__ + "img/logo-small-header.3aac7693.svg";